import { User, AppState, LoginState, isLoggedInState } from "../components/portal/state";
import * as React from "react"
import * as i18next from 'i18next'
import * as Components from '../components/components'
import * as CustomComponents from '../components/custom_components'
import { Action, loadingAsyncState } from "widgets-for-react";
import { State, ExtraUserInfo } from "./portal_client";
import { getCharacteristics } from "./portal_utils/api"
import * as Immutable from "immutable"
import { Characteristic } from "./characteristic";
import { ProductCharacteristics } from "./product_characteristics";
import { pushEventToDatalayer } from '../utils/analytics';
import { Counter } from "./counter";
import { CharacteristicValue } from "./portal/types";

export type ProductConfigurationProps = { user: () => User<ExtraUserInfo>, setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void, state: LoginState<State, ExtraUserInfo> }
export class ProductConfiguration extends React.Component<ProductConfigurationProps>  {
  constructor(props: ProductConfigurationProps, context: any) {
    super(props, context)
  }

  render() {
    let state = this.props.state;
    let { productConfigurations, selectedProductConfiguration } = this.props.state.appState;
    if (isLoggedInState(state)) {
      let prod_configs = state.appState.productConfigurations
      if (prod_configs.get(state.appState.selectedProductConfiguration)) {
        let ch = prod_configs.get(state.appState.selectedProductConfiguration).CharacteristicArray
      }
    }
    return isLoggedInState(state) && productConfigurations.get(selectedProductConfiguration) != undefined ?
      <>
        <h2 className="sr-text">Add product</h2>
        <section className="section">
          <div className="section__inner">
            <header className="section__header">
              <h3 className="section__title title--l">{i18next.t(`quotation_request:product:title_a`)}<span> {i18next.t(`quotation_request:product:title_b`)}</span></h3>
            </header>
            <div className="section__content">
              <div className="expand">
                <ol className="expand__list">
                  <li className={`expand__item ${("ProductId" === productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic) ? "expand__item--open" : ""}`}>
                    <Characteristic
                      user={this.props.user}
                      showSummary={"ProductId" != productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic}
                      setState={this.props.setState}
                      state={this.props.state}
                      label={i18next.t(`quotation_request:product.name`)}
                      characteristicId="ProductId"
                      helpText={i18next.t(`quotation_request:product.name_helptext`)}
                      characteristicValues={Immutable.List(isLoggedInState(state) && state.appState.products.kind == "loaded" ? state.appState.products.value.map(product => ({ value: product.Id.toString(), label: product.Name })) : [])}
                      component={
                        CustomComponents.Radio(
                          true,
                          'edit',
                          'products',
                          Immutable.List(isLoggedInState(state) && state.appState.products.kind == "loaded" ? state.appState.products.value.map(product => ({ value: product.Id.toString(), label: product.Name })) : []),
                          () => isLoggedInState(state) && state.appState.productConfigurations.get(state.appState.selectedProductConfiguration) ? state.appState.productConfigurations.get(state.appState.selectedProductConfiguration).ProductId.toString() : "0",
                          v => this.props.setState(s => {
                            if (isLoggedInState(s)) {
                              let prod_configs = s.appState.productConfigurations
                              prod_configs.get(s.appState.selectedProductConfiguration).ProductId = v
                              return ({ ...s, appState: { ...s.appState, productConfigurations: prod_configs } })
                            }
                          })
                        )
                      }
                    />
                  </li>

                  <li className={`expand__item ${("Count" === productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic) ? "expand__item--open" : ""}`}>
                    <Characteristic
                      user={this.props.user}
                      showSummary={"ProductId" != productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic && "Count" != productConfigurations.get(selectedProductConfiguration).SelectedCharacteristic}
                      setState={this.props.setState}
                      state={this.props.state}
                      label={i18next.t(`quotation_request:product.count`)}
                      characteristicId="Count"
                      characteristicValues={Immutable.List()}
                      component={
                        <Counter
                          handleDecrease={() => this.props.setState(s => {
                            if (isLoggedInState(s)) {
                              let prod_configs = s.appState.productConfigurations
                              prod_configs.get(selectedProductConfiguration).Count = prod_configs.get(selectedProductConfiguration).Count - 1
                              return ({ ...s, appState: { ...s.appState, productConfigurations: prod_configs } })
                            }
                          })}
                          handleIncrease={() => this.props.setState(s => {
                            if (isLoggedInState(s)) {
                              let prod_configs = s.appState.productConfigurations
                              prod_configs.get(selectedProductConfiguration).Count = prod_configs.get(selectedProductConfiguration).Count + 1
                              return ({ ...s, appState: { ...s.appState, productConfigurations: prod_configs } })
                            }
                          })}
                          isDisabled={this.props.state.appState.productConfigurations.get(selectedProductConfiguration).Count < 2}
                          label={isLoggedInState(state) && state.appState.productConfigurations.get(selectedProductConfiguration) ? state.appState.productConfigurations.get(selectedProductConfiguration).Count : 0}
                          {...this.props}
                        />
                      }
                    />
                  </li>

                  <ProductCharacteristics user={this.props.user} setState={this.props.setState} state={this.props.state} />
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section__inner">
            <header className="section__header">
              <h3 className="section__title title--l">
                {i18next.t(`quotation_request:product.comment_title_a`)}
                <span> {i18next.t(`quotation_request:product.comment_title_b`)}</span>
              </h3>
              <p className="section__intro section__text">{i18next.t(`quotation_request:product.comment_text`)}</p>
            </header>

            <div className="section__content">
              <div className="form--product-configuration">
                {Components.Text(
                  true,
                  'edit',
                  () => isLoggedInState(state) && state.appState.productConfigurations.get(state.appState.selectedProductConfiguration) ? state.appState.productConfigurations.get(state.appState.selectedProductConfiguration).SpecialFeature : "",
                  v => {
                    return this.props.setState(s => {
                      if (isLoggedInState(s)) {
                        let prod_configs = s.appState.productConfigurations;
                        prod_configs.get(s.appState.selectedProductConfiguration).SpecialFeature = v;
                        return ({ ...s, appState: { ...s.appState, productConfigurations: prod_configs } });
                      }
                    })
                  },
                  'product-configuration-comment',
                  'form__textarea',
                  4,
                  `${i18next.t(`quotation_request:product.comment_placeholder`)}`
                )}

                <div className="form__actions">
                  {/* TODO make button disabled when you haven't completed all steps? */}
                  <button
                    type="button"
                    className="button button--text-icon"
                    onClick={() => {
                      pushEventToDatalayer({ category: "Productconfigurator", action: "Finish specification" })
                      document.documentElement.classList.remove('panel--toggled');
                      this.props.setState(s => {
                        // Grab all and current config from state
                        const currentConfigId = s.appState.selectedProductConfiguration
                        const configs = s.appState.productConfigurations
                        const currentConfig = configs.get(currentConfigId)

                        // Generate "selections" from Characteristics with only one (remaining) option
                        const options = currentConfig.CharacteristicArray.kind == 'loaded' ? currentConfig.CharacteristicArray.value : []
                        const singleChoiceChars = options.filter(c => c.ValueOptions.length == 1)
                        const singleChoiceIds = Immutable.Set(singleChoiceChars.map(c => c.Id))
                        const forcedValues: CharacteristicValue[] = singleChoiceChars.map(ch => ({ CharacteristicId: ch.Id, CharacteristicValueId: ch.ValueOptions[0].ValueId }))

                        const CharacteristicValues = currentConfig
                          .CharacteristicValues                                   // Take the current selections
                          .filter(v => !singleChoiceIds.has(v.CharacteristicId))  // Leave out anything that might be duplicated by the generated selections
                          .concat(forcedValues)                                   // Append the generated selections

                        const updatedConfig = { ...currentConfig, CharacteristicValues, Submitted: true } // create the final config
                        const productConfigurations = configs.set(currentConfigId, updatedConfig)         // insert the final config into the map of configs

                        return ({ ...s, appState: { ...s.appState, productConfigurations, selectedProductConfiguration: "0", isPanelOpen: !s.appState.isPanelOpen, cachedCharacteristics: [] } });
                      })
                    }}
                  >
                    <span className="button__label">{i18next.t(`quotation_request:product.clickables.submit`)}</span>
                    <svg className="button__icon" width="20px" height="20px" aria-hidden="true">
                      <use xlinkHref="#icon--plus"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      :
      <></>
  }
}

export const ProductConfigurationElement =
  (
    user: () => User<ExtraUserInfo>,
    setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void,
    state: LoginState<State, ExtraUserInfo>
  ): JSX.Element => <ProductConfiguration user={user} setState={setState} state={state} />